
import firebase from 'firebase';
let firebaseApp;
SetupFirebase();

/**
* Firebase Initialization Function
* This must be called before any firebase query
*/
function SetupFirebase() {
    const firebaseConfig = {
        apiKey: "AIzaSyD68vXIx54gjqZRZLPCTOMNxh6vEDKMGvs",
        authDomain: "krishnahandloom-399bd.firebaseapp.com",
        databaseURL: "https://krishnahandloom-399bd.firebaseio.com",
        projectId: "krishnahandloom-399bd",
        storageBucket: "krishnahandloom-399bd.appspot.com",
        messagingSenderId: "231622416975",
        appId: "1:231622416975:web:8201a4f6279af7a708283a",
        measurementId: "G-BFJWH9C3K4"
    };
    // Initialize Firebase
    firebaseApp = firebase.initializeApp(firebaseConfig);
}

export default firebaseApp;
